// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReDate from "@mobily/rescript-date/src/ReDate.bs.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as App_Types_Date$DvmAdminFrontendFr from "../../../common/types/App_Types_Date.bs.js";
import * as Flash_Edit_Types$DvmAdminFrontendFr from "./Flash_Edit_Types.bs.js";
import * as User_Types_Utils$DvmAdminFrontendFr from "../../../context/user/User_Types_Utils.bs.js";
import * as Messages_Error_Inputs$DvmAdminFrontendFr from "../../../intl/messages/Messages_Error_Inputs.bs.js";

function actionHasVO(flash) {
  if (Belt_Option.getWithDefault(flash.carAgeAtOrderSelected, false) || Belt_Option.getWithDefault(flash.carAgeAtDeliverySelected, false) || Belt_Option.getWithDefault(flash.possessionPeriodAtOrderSelected, false) || Belt_Option.getWithDefault(flash.possessionPeriodAtDeliverySelected, false) || Belt_Option.isSome(flash.carAgeAtOrderDate) || Belt_Option.isSome(flash.carAgeAtDeliveryDate) || Belt_Option.isSome(flash.possesionPeriodAtOrderDate) || Belt_Option.isSome(flash.possesionPeriodAtDeliveryDate)) {
    return true;
  } else {
    return Belt_Option.isSome(flash.brands);
  }
}

function getOrderTypeGroup(orderType) {
  switch (orderType) {
    case /* SO */0 :
        return /* SO */0;
    case /* VD */3 :
        return /* VD */4;
    case /* RR */4 :
        return /* RR */5;
    case /* RC */5 :
        return /* RC */6;
    case /* RS */8 :
        return /* RS */7;
    case /* VE */2 :
    case /* AD */10 :
        return /* VE_AD */2;
    case /* ES */6 :
    case /* AS */11 :
        return /* ES_AS */3;
    case /* CL */1 :
    case /* EP */7 :
    case /* RP */9 :
    case /* AP */12 :
        return /* CL_EP_RP_AP */1;
    case /* NOTSET */13 :
        return /* NOTSET */8;
    
  }
}

function orderTypeSelectable(orderType, group) {
  if (group === /* NOTSET */8) {
    return false;
  }
  var match = Belt_Option.getWithDefault(Flash_Edit_Types$DvmAdminFrontendFr.OrderType.fromString(orderType), /* NOTSET */13);
  var tmp;
  switch (match) {
    case /* SO */0 :
        tmp = group === /* SO */0;
        break;
    case /* VD */3 :
        tmp = group === /* VD */4;
        break;
    case /* RR */4 :
        tmp = group === /* RR */5;
        break;
    case /* RC */5 :
        tmp = group === /* RC */6;
        break;
    case /* RS */8 :
        tmp = group === /* RS */7;
        break;
    case /* VE */2 :
    case /* AD */10 :
        tmp = group === /* VE_AD */2;
        break;
    case /* ES */6 :
    case /* AS */11 :
        tmp = group === /* ES_AS */3;
        break;
    case /* CL */1 :
    case /* EP */7 :
    case /* RP */9 :
    case /* AP */12 :
        tmp = group === /* CL_EP_RP_AP */1;
        break;
    case /* NOTSET */13 :
        tmp = true;
        break;
    
  }
  return !tmp;
}

function orderGroupOptions(orderType, selectedRole) {
  if (User_Types_Utils$DvmAdminFrontendFr.whatCountry(selectedRole) !== /* France */0) {
    return {
            hd: "CL",
            tl: {
              hd: "VD",
              tl: {
                hd: "VE",
                tl: {
                  hd: "RR",
                  tl: {
                    hd: "RC",
                    tl: /* [] */0
                  }
                }
              }
            }
          };
  }
  var defaultList = selectedRole === /* DPR */10 ? ({
        hd: "CL",
        tl: {
          hd: "ES",
          tl: {
            hd: "EP",
            tl: {
              hd: "RS",
              tl: {
                hd: "RP",
                tl: {
                  hd: "AS",
                  tl: {
                    hd: "AP",
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }) : ({
        hd: "SO",
        tl: {
          hd: "CL",
          tl: {
            hd: "VD",
            tl: {
              hd: "VE",
              tl: {
                hd: "RR",
                tl: {
                  hd: "RC",
                  tl: {
                    hd: "ES",
                    tl: {
                      hd: "EP",
                      tl: {
                        hd: "RS",
                        tl: {
                          hd: "RP",
                          tl: {
                            hd: "AD",
                            tl: {
                              hd: "AS",
                              tl: {
                                hd: "AP",
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
  switch (orderType) {
    case /* CL_EP_RP_AP */1 :
        return {
                hd: "CL",
                tl: {
                  hd: "EP",
                  tl: {
                    hd: "RP",
                    tl: {
                      hd: "AP",
                      tl: /* [] */0
                    }
                  }
                }
              };
    case /* VE_AD */2 :
        return {
                hd: "VE",
                tl: {
                  hd: "AD",
                  tl: /* [] */0
                }
              };
    case /* ES_AS */3 :
        return {
                hd: "ES",
                tl: {
                  hd: "AS",
                  tl: /* [] */0
                }
              };
    case /* SO */0 :
    case /* VD */4 :
    case /* RR */5 :
    case /* RC */6 :
    case /* RS */7 :
    case /* NOTSET */8 :
        return defaultList;
    
  }
}

function orderListToGroup(orderTypes) {
  var groupList = Belt_List.map(Belt_SetString.toList(Belt_SetString.fromArray(Belt_List.toArray(Belt_List.map(orderTypes, (function (x) {
                          return Flash_Edit_Types$DvmAdminFrontendFr.orderGroupToString(getOrderTypeGroup(x));
                        }))))), Flash_Edit_Types$DvmAdminFrontendFr.orderGroupFromString);
  if (Belt_List.length(groupList) > 1) {
    return /* NOTSET */8;
  } else {
    return Belt_Option.getWithDefault(Belt_List.get(groupList, 0), /* NOTSET */8);
  }
}

function validateDate(smallerDate, largerDate, thisDate, requiredSmaller, requiredLarger, needsSameYearOpt, param) {
  var needsSameYear = needsSameYearOpt !== undefined ? needsSameYearOpt : false;
  var match = thisDate === "smaller" ? [
      smallerDate,
      largerDate,
      requiredSmaller,
      requiredLarger
    ] : [
      largerDate,
      smallerDate,
      requiredLarger,
      requiredSmaller
    ];
  var requiredThat = match[3];
  var that = match[1];
  return Belt_Option.mapWithDefault(match[0], match[2] ? ({
                  TAG: /* Error */1,
                  _0: Messages_Error_Inputs$DvmAdminFrontendFr.fieldRequired
                }) : ({
                  TAG: /* Ok */0,
                  _0: undefined
                }), (function ($$this) {
                if (App_Types_Date$DvmAdminFrontendFr.isValid($$this)) {
                  return Belt_Option.mapWithDefault(that, requiredThat ? ({
                                  TAG: /* Error */1,
                                  _0: Messages_Error_Inputs$DvmAdminFrontendFr.otherDateNotValid
                                }) : ({
                                  TAG: /* Ok */0,
                                  _0: Caml_option.some($$this)
                                }), (function (that) {
                                if (App_Types_Date$DvmAdminFrontendFr.isValid(that)) {
                                  if (ReDate.getYear($$this) === ReDate.getYear(that) || !needsSameYear) {
                                    if (thisDate === "smaller") {
                                      if ($$this.valueOf() < that.valueOf()) {
                                        return {
                                                TAG: /* Ok */0,
                                                _0: Caml_option.some($$this)
                                              };
                                      } else {
                                        return {
                                                TAG: /* Error */1,
                                                _0: Messages_Error_Inputs$DvmAdminFrontendFr.dateTooLarge
                                              };
                                      }
                                    } else if ($$this.valueOf() > that.valueOf()) {
                                      return {
                                              TAG: /* Ok */0,
                                              _0: Caml_option.some($$this)
                                            };
                                    } else {
                                      return {
                                              TAG: /* Error */1,
                                              _0: Messages_Error_Inputs$DvmAdminFrontendFr.dateTooSmall
                                            };
                                    }
                                  } else {
                                    return {
                                            TAG: /* Error */1,
                                            _0: Messages_Error_Inputs$DvmAdminFrontendFr.datesNotSameYear
                                          };
                                  }
                                } else {
                                  return {
                                          TAG: /* Error */1,
                                          _0: Messages_Error_Inputs$DvmAdminFrontendFr.otherDateNotValid
                                        };
                                }
                              }));
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: Messages_Error_Inputs$DvmAdminFrontendFr.invalidField
                        };
                }
              }));
}

export {
  actionHasVO ,
  getOrderTypeGroup ,
  orderTypeSelectable ,
  orderGroupOptions ,
  orderListToGroup ,
  validateDate ,
}
/* App_Types_Date-DvmAdminFrontendFr Not a pure module */
